import { render, staticRenderFns } from "./backHelpCenter.vue?vue&type=template&id=08933338&scoped=true"
import script from "./backHelpCenter.vue?vue&type=script&lang=js"
export * from "./backHelpCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08933338",
  null
  
)

export default component.exports